import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import LoadingSpinner from "../LoadingSpinner";

export default function AccoladeDialog({
  open,
  onClose,
  isAccoladeEdit,
  handleAccoladeSubmit,
  handleAccoladeSubmission,
  selectedType,
  setValue,
  errors,
  accoladeRegister,
  allStateOptions,
  allConferenceOptions,
  classifications,
  date,
  loading,
  resetAccolade,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-xl w-full space-y-4 border bg-white rounded-lg p-6">
          <DialogTitle className="text-xl uppercase pb-4">
            {isAccoladeEdit ? "Edit Accolade" : "New Accolade"}
          </DialogTitle>
          <form onSubmit={handleAccoladeSubmit(handleAccoladeSubmission)}>
            <div className="my-5">
              <label className="block text-xs font-bold uppercase mb-2">
                Select Type
              </label>
              <div className="flex gap-6 text-sm">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    value="ALL_STATE"
                    checked={selectedType === "ALL_STATE"}
                    onChange={(e) =>
                      setValue("accoladeType", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    className="h-4 w-4"
                  />
                  All State
                </label>
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    value="ALL_CONFERENCE"
                    checked={selectedType === "ALL_CONFERENCE"}
                    onChange={(e) =>
                      setValue("accoladeType", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    className="h-4 w-4"
                  />
                  All Conference / Region
                </label>
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    value="OTHER"
                    checked={selectedType === "OTHER"}
                    onChange={(e) =>
                      setValue("accoladeType", e.target.value, {
                        shouldValidate: true,
                      })
                    }
                    className="h-4 w-4"
                  />
                  Other
                </label>
              </div>
              {errors.accoladeType && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.accoladeType.message}
                </p>
              )}
            </div>

            {selectedType && selectedType !== "OTHER" && (
              <div className="mb-6">
                <label className="block text-xs font-bold uppercase mb-2">
                  Description
                </label>
                <select
                  {...accoladeRegister("accoladeDescription", {
                    required:
                      selectedType !== "OTHER"
                        ? "Description is required"
                        : false,
                  })}
                  className="w-full border border-gray-300 rounded p-3"
                >
                  <option value="">Select description</option>
                  {(selectedType === "ALL_STATE"
                    ? allStateOptions
                    : allConferenceOptions
                  ).map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
                {errors.accoladeDescription && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.accoladeDescription.message}
                  </p>
                )}
              </div>
            )}

            <div className="mb-6">
              <label className="block text-xs font-bold uppercase mb-2">
                Classification
              </label>
              <select
                {...accoladeRegister("accoladeClassification", {
                  required: "Classification is required",
                })}
                className="w-full border border-gray-300 rounded p-3"
              >
                <option value="">Select classification</option>
                {classifications.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
              {errors.accoladeClassification && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.accoladeClassification.message}
                </p>
              )}
            </div>

            <div className="mb-4">
              <label className="block text-xs font-bold uppercase mb-2">
                Year
              </label>
              <input
                type="number"
                min={2000}
                max={date.year()}
                {...accoladeRegister("accoladeYear", {
                  required: "Year is required",
                  valueAsNumber: true,
                })}
                className="w-full border border-gray-300 rounded p-3"
              />
              {errors.accoladeYear && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.accoladeYear.message}
                </p>
              )}
            </div>

            {selectedType === "OTHER" && (
              <div className="mb-6">
                <label className="block text-xs font-bold uppercase mb-2">
                  Description
                </label>
                <textarea
                  {...accoladeRegister("accoladeDescription", {
                    required: "Description is required",
                  })}
                  className="w-full border border-gray-300 rounded p-3"
                  rows={3}
                  placeholder="Enter description"
                />
                {errors.accoladeDescription && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.accoladeDescription.message}
                  </p>
                )}
              </div>
            )}

            {loading && <LoadingSpinner />}

            <div className="flex gap-4 sm:flex-row-reverse pt-4">
              <button
                type="submit"
                className="bg-red-500 text-white px-8 py-3 rounded-md uppercase text-sm hover:bg-red-700"
              >
                {isAccoladeEdit ? "Update" : "Add"}
              </button>
              <button
                type="button"
                onClick={() => {
                  onClose();
                  resetAccolade({
                    accoladeType: "ALL_STATE",
                    accoladeYear: date.year(),
                  });
                }}
                className="text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
            </div>
          </form>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
